// @flow
import { useMemo } from 'react';
import { useMutation } from 'react-query';
import ApplicantService from '../../../../../services/applicantService';

import type { MutationOptions } from 'react-query';
import type { PetMutationResponse } from '../../types';

/** Permanently deletes a pet through its Applicant record. */
const useHardDeletePetMutation = ({
  organizationId,
  propertyId,
  options,
}: {
  organizationId: string,
  propertyId: string,
  options?: MutationOptions,
}) => {
  const applicantService = useMemo(() => new ApplicantService(), []);

  return useMutation(
    (applicantId: string): Promise<PetMutationResponse> =>
      applicantService.hardDeleteApplicant(
        organizationId,
        propertyId,
        applicantId,
      ),
    options,
  );
};

export default useHardDeletePetMutation;
